import classNames from 'classnames';
import { FC } from 'react';

interface iButton {
  active?: boolean;
  disabled?: boolean;
  onMouseDown: (e: any) => void;
  info?: string;
}
const Button: FC<iButton> = ({ active, onMouseDown, children, disabled, info }) => {
  return (
    <span className={classNames('button', active && 'active', disabled && 'disabled')} onMouseDown={onMouseDown}>
      {children}
      {info && (
        <div className='info-wrapper'>
          <div className='popup'>{info || 'Qui est ut occaecat minim anim duis nostrud ad exercitation ad duis.'}</div>
        </div>
      )}
    </span>
  );
};

export default Button;
